<template>
    <div class="Sidebar" v-if="sidebar">
        <SidebarLevel1 v-if="sidebar.admin && sidebar.admin.length > 0"
                       title="Administration"
                       :items="sidebar.admin"
                       id="sidebarAdmin"
                       key="sidebarAdmin"
        >
        </SidebarLevel1>

        <SidebarLevel1 v-if="sidebar.config && sidebar.config.length > 0"
                       title="Configuration"
                       :items="sidebar.config"
                       id="sidebarConfig"
                       key="sidebarConfig"
        >
        </SidebarLevel1>

        <SidebarLevel1 v-if="sidebar.settings && sidebar.settings.length > 0"
                       title="Settings"
                       :items="sidebar.settings"
                       id="sidebarSettings"
                       key="sidebarSettings"
        >
        </SidebarLevel1>

        <div v-if="sidebar.steps && sidebar.steps.length > 0"
             style="flex: 0 0 100%; width: 100%;"
        >
            <SidebarLevel1 v-for="(step, index) in sidebar.steps"
                           :key="index"
                           :title="step.name"
                           icon="fas fa-minus-circle"
                           :sections="step.sections"
                           :complete="step.complete"
                           :id="'sidebar'+slugify(step.name)+index"
            >
            </SidebarLevel1>
        </div>

        <div class="CompletionButton">
            <v-btn color="primary" @click="initSiteCompletion">
                {{ siteCompletionButtonText }}
            </v-btn>
            <v-dialog max-width="500" v-model="siteCompletionModal">
                <v-card>
                    <v-card-title>
                        {{ siteCompletionScheduleNotificationTitle }}
                    </v-card-title>
                    <v-card-text>
                        <p>{{ siteCompletionScheduleNotificationText }}</p>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancelCompletion">Cancel</v-btn>
                        <v-btn color="primary" @click="completeSite">
                            <v-icon left small>fas fa-calendar-alt</v-icon>
                            Request Review
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import axios from 'axios';
import store from '../../store/store';
import SidebarLevel1 from './SidebarLevel1';
import makeSlug from '@/helpers/slugify';

export default {
    name: 'Sidebar',
    components: { SidebarLevel1 },
    computed: {
        ...mapState('auth', ['user']),

        siteCompletionButtonText() {
            return store.state.settings.settings['settingSiteCompletion'].siteCompletionButtonText;
        },

        siteCompletionScheduleUrl() {
            return store.state.settings.settings['settingSiteCompletion'].siteCompletionScheduleUrl;
        },

        siteCompletionScheduleNotificationTitle() {
            return store.state.settings.settings['settingSiteCompletion'].siteCompletionScheduleNotificationTitle;
        },

        siteCompletionScheduleNotificationText() {
            return store.state.settings.settings['settingSiteCompletion'].siteCompletionScheduleNotificationText;
        },

        sidebar: {
            get() {
                return store.state.sidebar.sidebar;
            },
            set(value) {
                this.setSidebar(value);
            }
        },
    },

    data() {
        return {
            siteCompletionModal: false,
        };
    },

    mounted() {
        if (this.user.role !== 'builder' && this.user.role !== 'support') {
            this.setupSidebar();
        }
    },

    methods: {
        ...mapMutations({
            setSidebarLoader: 'sidebar/setSidebarLoader',
            setSidebar: 'sidebar/setSidebar'
        }),

        ...mapActions({
            getSidebar: 'sidebar/getSidebar',
        }),

        setupSidebar() {
            this.setSidebarLoader(true);
            this.getSidebar();
        },

        slugify(str) {
            return makeSlug(str);
        },

        initSiteCompletion() {
            this.siteCompletionModal = true;
        },

        completeSite() {
            let newWindow =  window.open('', '_blank');
            axios.post('/api/site/complete')
                .then(() => {
                    newWindow.location = this.siteCompletionScheduleUrl;
                    this.siteCompletionModal = false;
                })
                .catch(() => {});
        },

        cancelCompletion() {
            this.siteCompletionModal = false;
        }
    }
};
</script>
<style lang="scss">
    .Sidebar {
        display: flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        flex: 0 0 100%;
        width: 100%;
        padding-top: 18px;
    }

    .Sidebar__level-1,
    .Sidebar__level-2 {
        display: flex;
        flex-flow: row wrap;
        align-content: center;
        align-items: center;
        flex: 0 0 100%;
        width: 100%;
        list-style: none;
        padding: 0 !important;
    }

    .Sidebar__level-1 {
        &.jsExpanded {
            padding-bottom: 12px !important;
        }

        button {
            color: white;
            background-color: transparent;
            border: 0 none !important;
            outline: none !important;
            transition: color 0.2s linear, background-color 0.2s linear;

            &:hover,
            &:focus {
                color: white;
                background-color: rgba($secondary-500, 0);
                border: 0 none !important;
                outline: none !important;
                transition: color 0.2s linear, background-color 0.2s linear;
            }

            &.jsExpanded {
                color: white;
                border: 0 none !important;
                outline: none !important;
                background-color: rgba($secondary-500, 0);
            }
        }
    }

    .Sidebar__level-2 {

    }

    .Sidebar__level-1__item,
    .Sidebar__level-2__item {
        display: flex;
        flex-flow: row wrap;
        align-content: center;
        align-items: center;
        flex: 0 0 100%;
        width: 100%;

        a {
            display: flex;
            flex-flow: row wrap;
            align-content: center;
            align-items: center;
            flex: 0 0 100%;
            width: 100%;
            padding: 0 !important;
            background-color: transparent;
            border-left: 10px solid transparent;
            text-decoration: none;
            color: white !important;
            transition: color 0.2s linear, background-color 0.2s linear, border 0.2s linear;
            outline: none !important;

            &:hover,
            &:focus {
                color: white !important;
                border-left: 10px solid transparent;
                background-color: $primary-500;
                transition: color 0.2s linear, background-color 0.2s linear, border 0.2s linear;
            }

            &:active {
                color: white !important;
                border-left: 10px solid transparent;
                background-color: transparent;
                transition: color 0.2s linear, background-color 0.2s linear, border 0.2s linear;
            }

            &.router-link-exact-active {
                color: white !important;
                border-left: 10px solid $primary-500;
                background-color: rgba(black, 0.1);
                transition: color 0.2s linear, background-color 0.2s linear, border 0.2s linear;
                cursor: default;
            }
        }
    }

    .Sidebar__level-1__heading,
    .Sidebar__level-2__heading {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-content: center;
        align-items: center;
        flex: 0 0 100%;
        width: 100%;
        height: 48px;
        padding: 0 28px 0 12px;
    }

    .Sidebar__level-1__heading {
        padding-top: 16px !important;
        padding-bottom: 16px !important;
    }

    .Sidebar__level-2__heading {
        height: 36px;
        padding: 18px 28px 18px 30px;
    }

    .Sidebar__level-1__toggle,
    .Sidebar__level-2__toggle {
        flex: 0 0 28px;
        width: 28px;
        color: white;
        font-size: 0.8rem;
    }

    .Sidebar__level-1__title,
    .Sidebar__level-2__title {
        flex: 0 0 auto;
        width: auto;
        padding-left: 8px;
    }

    .Sidebar__level-1__title {
        font-size: 0.98rem;
    }

    .Sidebar__level-2__title {
        font-size: 0.9rem;
    }

    .Sidebar__level-1__status,
    .Sidebar__level-2__status {
        flex: 0 0 auto;
        width: auto;
        margin-left: auto;
        margin-top: 1px;
        color: $primary-500 !important;
        font-size: 1.09rem;

        &.jsComplete {
            color: white !important;
        }
    }

    .Sidebar__level-2__status {
        font-size: 0.85rem;
        padding-right: 0.12rem;
    }

    .CompletionButton {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        flex: 0 0 100%;
        width: 100%;
        margin-top: 24px;
        margin-bottom: 60px;
        padding: 0 24px;

        button {
            flex: 0 0 100%;
            width: 100%;
        }
    }
</style>
